import { render, staticRenderFns } from "./CategoryExpansionPanel.vue?vue&type=template&id=4270a9e1&scoped=true&"
import script from "./CategoryExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./CategoryExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./CategoryExpansionPanel.vue?vue&type=style&index=0&id=4270a9e1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4270a9e1",
  null
  
)

export default component.exports